import { FormControl, FormGroup } from '@angular/forms';
import { PolygonMapItem } from '../polygon-map-item';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';

@RegisterElement()
export class Stairs extends PolygonMapItem {
    public override TypeName: string = "Stairs";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "MapItems";

    constructor(formGroup: FormGroup) {
        super(formGroup, "Stairs");
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('Direction')) {
            formGroup.addControl('Direction', new FormControl('up'));
        }
        if (!formGroup.contains('Width')) {
            formGroup.addControl('Width', new FormControl(1.2)); // 1.2m default width
        }
        if (!formGroup.contains('Length')) {
            formGroup.addControl('Length', new FormControl(3)); // 3m default length
        }
        
        if(formGroup.contains('StrokeColor'))
            this.OutlineColor = '#' + formGroup.get('StrokeColor')?.value;
        else
            this.OutlineColor = "#666666";
        if(formGroup.contains('FillColor'))
            this.FillColor = '#' + formGroup.get('FillColor')?.value;
        else
            this.FillColor = "#777777";
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Stair Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            },
            {
                formControlName: 'Direction',
                displayName: 'Direction',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'up', label: 'Up' },
                        { value: 'down', label: 'Down' },
                        { value: 'both', label: 'Both' }
                    ]
                },
                order: 2,
                category: 'Properties'
            },
            {
                formControlName: 'Width',
                displayName: 'Width',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 3,
                category: 'Dimensions'
            },
            {
                formControlName: 'Length',
                displayName: 'Length',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 4,
                category: 'Dimensions'
            }
        ];
    }

    public override default(): Stairs {
        const width = this.formGroup.get('Width')?.value || 1.2;
        const length = this.formGroup.get('Length')?.value || 3;
        
        this.points = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width, y: length },
            { x: 0, y: length }
        ];
        return this;
    }

    public override clone(): Stairs {
        return new Stairs(this.formGroup);
    }

} 
